import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-copy_right",
  "use": "icon-copy_right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-copy_right\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.44 4.592a.6.6 0 0 1-.032.848l-6.921 6.418L2.55 7.397a.6.6 0 1 1 .9-.794l3.123 3.539 6.02-5.582a.6.6 0 0 1 .847.032z\" fill=\"#2BBF57\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol